/**
 * Settings MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import { SETTINGS_CORE_QUERY_KEY, fetchSettingsCoreFromApi } from "./settingsQueryApi";

export const settingsQueryClient = makeMv2QueryClient();
setupMv2CachePersist(settingsQueryClient, "settings");

export function prefetchSettings() {
  return settingsQueryClient.prefetchQuery({
    queryKey: [SETTINGS_CORE_QUERY_KEY],
    queryFn: ({ signal }) => fetchSettingsCoreFromApi(signal),
  });
}
